import { render } from "./GeneralInformation.htm?vue&type=template&id=39576ca6&scoped=true&ts=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=ts"
export * from "./GeneralInformation.vue?vue&type=script&lang=ts"

import "./GeneralInformation.scss?vue&type=style&index=0&id=39576ca6&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39576ca6"]])

export default __exports__